import React from "react";
import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import { SVGExpand } from "./icon/SVGExpand";
import { SVGCollapse } from "./icon/SVGCollapse";

export const ListItem = (props: { item: any }) => {
    return (
        <li className="navbar-component_mobile-drawer-content-scroll-list-group-list-item">
            {
                props.item.isExternal ? 
                    (   
                        <a className="navbar-component_mobile-drawer-content-scroll-list-group-list-item-link" href={props.item.href} {...props.item.attributes}>
                            { props.item.name }
                        </a>
                    ) : (
                        <a className="navbar-component_mobile-drawer-content-scroll-list-group-list-item-link" href={props.item.href} target='_blank' rel='noreferrer' {...props.item.attributes}>
                            { props.item.name }
                        </a>
                    )
            }
        </li>
    );
};

export const ListGroup = (props: { heading: string, isCollapsible: boolean, items: any[] }) => {
    const firstUpdate = useRef(true);


    const [isCollapsed, setIsCollapsed] = useState(false);

    const ul: any = useRef(null);
    const heading: any = useRef(null);

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        if (props.isCollapsible) {
            $(heading.current).toggleClass('expand');
            $(ul.current).toggle(200);
            $('.navbar-component_mobile-drawer-content-scroll').animate({
                scrollTop: $('.navbar-component_mobile-drawer-content-scroll')[0]!.scrollHeight,
            }, 200);
        }
    }, [isCollapsed, props.isCollapsible])


    const onToggleExpand = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <li className={`navbar-component_mobile-drawer-content-scroll-list-group ${props.isCollapsible ? 'js-navigation-drawer-list-group-collapsible' : ''}`}>
            <div className={`navbar-component_mobile-drawer-content-scroll-list-group-heading`} onClick={onToggleExpand} ref={heading}>
                { props.heading }
                { props.isCollapsible && <SVGExpand /> }
                { props.isCollapsible && <SVGCollapse /> }
            </div>

            <ul className="navbar-component_mobile-drawer-content-scroll-list-group-list" style={(props.isCollapsible) ? {display: 'none'} : {}} ref={ul}>
                { props.items.map(item => <ListItem item={item} key={item.name}/>) }
            </ul>
        </li>
    );
};

export default ListGroup;
